const baseQueries = new URLSearchParams([
  // ["per_page", "12"],
  ["direction", "ASC"],
  ["order_by", "title"],
  ["page", "1"],
  ["min_price", "0"],
  ["max_price", "500"],
]);
export default baseQueries;
